export const SETTINGS_MESSAGE = {
	UPDATE_FAILURE: 'Cập nhật không thành công',
	MAX_SALE_RATE: 'Không thể đặt tỉ lệ hoa hồng quá 100%',
	MIN_EXCHANGE_RATE: 'Không thể đặt tỉ lệ quá 20.000 đ',
};
